import React from "react";
import {NavLink, Route, Switch} from "react-router-dom"
import {rolePageMapping} from "./utils/roles";

const Navigation = (props) => {
    return (
        <div className="Navigation">
            <Switch>
                <Route exact path={"/"}>
                </Route>
                <Route>
                    <div className="tableWrapper">
                        {(props.tabsEnabledStatus === 'MINIMAL') ? (
                            <ul className="header">
                                {
                                    rolePageMapping.supplyencoding.includes(props.role)
                                    &&
                                    <li><NavLink to="/supply-encoding-home">Supply Data Upload/Download</NavLink></li>
                                }
                                {
                                    rolePageMapping.download.includes(props.role)
                                    &&
                                    <li><NavLink to="/printer">Printer FW Download</NavLink></li>
                                }

                            </ul>) : (<ul className="header">
                                {
                                    rolePageMapping.supplycatalog.includes(props.role)
                                    &&
                                    <li><NavLink to="/sps-supply-catalog">Supply Catalog</NavLink></li>
                                }
                                {
                                    rolePageMapping.fwcatalog.includes(props.role)
                                    &&
                                    <li><NavLink to="/fw-catalog">FW Catalog</NavLink></li>
                                }
                                {
                                    rolePageMapping.swcatalogupload.includes(props.role)
                                    &&
                                    <li><NavLink to="/sw-catalog">SW Catalog</NavLink></li>
                                }
                                {
                                    rolePageMapping.supplyencoding.includes(props.role)
                                    &&
                                    <li><NavLink to="/supply-encoding-home">Supply Data Upload/Download</NavLink></li>
                                }
                                {
                                    rolePageMapping.supplyinspection.includes(props.role)
                                    &&
                                    <li><NavLink to="/supplyinspection">Supply Inspection</NavLink></li>
                                }
                                {
                                    rolePageMapping.account.includes(props.role)
                                    &&
                                    <li><NavLink to="/account">Account Details</NavLink></li>
                                }
                                {
                                    rolePageMapping.download.includes(props.role)
                                    &&
                                    <li><NavLink to="/printer">Printer FW Download</NavLink></li>
                                }
                                {
                                    rolePageMapping.admin.includes(props.role)
                                    &&
                                    <li><NavLink to="/operator">Administration</NavLink></li>
                                }
                            </ul>
                        )
                        }
                    </div>
                </Route>
            </Switch>
        </div>
    )
}

export default Navigation;